module.exports = __webpack_public_path__ + "img/supply.9d3cc7c0.svg";